import axios from 'axios'
import store from '../store'

/**
 * Set a bearer token for testing purposes
 * @param {string} token - The bearer token to set
 * @param {Object} [user] - Optional user object to associate with the token
 * @returns {boolean} - Success status
 */
export const setTestToken = (token, user = null) => {
  try {
    store.dispatch('auth/setTestToken', { token, user })
    return true
  } catch (error) {
    console.error('Error setting test token:', error)
    return false
  }
}

/**
 * Get the current bearer token
 * @returns {string|null} - The current bearer token or null if not authenticated
 */
export const getToken = () => {
  return store.getters['auth/token']
}

/**
 * Check if the user is authenticated
 * @returns {boolean} - True if authenticated, false otherwise
 */
export const isAuthenticated = () => {
  return store.getters['auth/isAuthenticated']
}

/**
 * Set the authorization header for axios requests
 * @param {string} token - The bearer token to set
 */
export const setAuthHeader = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  } else {
    delete axios.defaults.headers.common['Authorization']
  }
}

/**
 * Clear authentication data (logout)
 */
export const clearAuth = () => {
  store.dispatch('auth/logout')
}

/**
 * Initialize authentication from localStorage (call this on app startup)
 */
export const initAuth = () => {
  const token = localStorage.getItem('token')
  if (token) {
    setAuthHeader(token)
  }
} 